import { create } from "zustand";

type AudioPlayerState = {
  activeId: string | null;
  setActive: (id: string | null) => void;
};

export const useAudioPlayer = create<AudioPlayerState>((set) => ({
  activeId: null,
  setActive: (id) => set({ activeId: id }),
}));
